import React from 'react'
import Header from './Header'

const Default =  ( props ) => {
  return (
    <div className="page-wrapper compact-wrapper" id="pageWrapper"> 

        <Header />
        <div className="page-body-wrapper">
            {props.children}
        </div>
    
    </div>
  )
}

export default Default